<style lang="scss" scoped>
.confirm-company-scopes {
	&__footer {
		margin-top: 30px;
	}
	ul {
		li {
			font-size: 0.8em;
		}
	}
}
.necessity {
	color: #4c85ff;
}
.required {
	color: #e00d22;
}
</style>

<template lang="pug"> 
    .confirm-company-scopes
        p Review your permissions:
        .confirm-company-scopes--changed(v-if="changed.length")
            h4 Changed ({{changed.length}}):
            ul
                li(v-for="(row, i) in changed", :key="row.id") {{ row.nice_name}} 
                    | &nbsp;(
                    span.necessity(:class="[{ required: !row.optional }]") {{ row.optional ? 'optional' : 'required' }}
                    | )
        .confirm-company-scopes--added(v-if="added.length")
            h4 Added ({{added.length}}):
            ul
                li(v-for="(row, i) in added", :key="row.id") {{ row.nice_name}}
                    | &nbsp;(
                    span.necessity(:class="[{ required: !row.optional }]") {{ row.optional ? 'optional' : 'required' }}
                    | )
        .confirm-company-scopes--added(v-if="removed.length")
            h4 Removed ({{removed.length}}):
            ul
                li(v-for="(row, i) in removed", :key="row.id") {{ row.nice_name}}
                    | &nbsp;(
                    span.necessity(:class="[{ required: !row.optional }]") {{ row.optional ? 'optional' : 'required' }}
                    | )
        .confirm-company-scopes__footer
            el-button(@click="$vuedals.close(false)") Cancel
            el-button(type="success", @click="$vuedals.close(true)") Submit for Review
</template>

<script>
export default {
	name: "ConfirmCompanyScopes",
	props: {
		added: {
			type: Array,
			default: () => []
		},
		removed: {
			type: Array,
			default: () => []
		},
		changed: {
			type: Array,
			default: () => []
		}
	}
};
</script>
